import React from 'react';
import { FontFamily, PrimaryButton } from 'utils/imports.utils';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';
import { formatInvoiceDate, formatPaiseToRupees, hasMoreInvoices } from 'utils/functions.utils';
import { STRINGS } from 'constants/strings.constant';
import { Invoice } from 'interfaces/invoice.interface';
import { AccountBillsTabProps } from 'interfaces/account_settings.interface';
import './account_bills_tab.component.scss';

const AccountBillsTab: React.FC<AccountBillsTabProps> = ({ invoices, total, isLoading, isLoadingMore, hasError, onLoadMore }) => {
  const text = STRINGS.accountSettings.myBills;
  return (
    <div className="account_bills">
      <h2 className="account_settings_panel_heading">{text.title}</h2>
      <p className="account_settings_panel_subheading">{text.subtitle}</p>
      {isLoading && <div className="account_bills_message">{text.loading}</div>}
      {!isLoading && !hasError && invoices.length === 0 && <div className="account_bills_message">{text.empty}</div>}
      {invoices.length > 0 && (
        <div className="account_bills_table" role="table" aria-label={text.title}>
          <div className="account_bills_header" role="row">
            {Object.values(text.columns).map((heading) => (
              <span key={heading} role="columnheader">
                {heading}
              </span>
            ))}
          </div>
          {invoices.map((invoice: Invoice) => (
            <div key={invoice._id} className="account_bills_row" role="row">
              <div role="cell">{formatInvoiceDate(invoice.issued_at)}</div>
              <div role="cell" className="account_bills_number">
                {invoice.invoice_number}
              </div>
              <div role="cell">{formatPaiseToRupees(invoice.net_amount)}</div>
              <div role="cell">{formatPaiseToRupees(invoice.gst_amount)}</div>
              <div role="cell" className="account_bills_total">
                {formatPaiseToRupees(invoice.total_amount)}
              </div>
              {/* An invoice only exists once its payment succeeded, so every row reads "Paid". */}
              <div role="cell">
                <span className="account_bills_status">
                  <span className="account_bills_status_dot" />
                  {text.paid}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
      {hasError && <div className="account_bills_message account_bills_message_error">{text.error}</div>}
      {hasMoreInvoices(invoices.length, total) && (
        <div className="account_bills_load_more">
          <PrimaryButton
            text={text.loadMore}
            type={ButtonTypes.SECONDARY}
            size={ButtonSize.MEDIUM}
            fontFamily={FontFamily.medium}
            onClick={onLoadMore}
            activity={isLoadingMore}
            disabled={isLoadingMore}
          />
        </div>
      )}
    </div>
  );
};

export default AccountBillsTab;
